/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useNavigate } from 'react-router';

import { KAI_SHIKI_LAYOUT, KAI_SHIKI_TYPOGRAPHY } from '@/Client/Styles/kaiShikiTokens';
import { usePageTitle } from '../Lib';
import { Button } from '../Widgets';

const PAGE_STYLE = css`
  label: MOBILE_ISSUE_VIDEO_HOME_PAGE_STYLE;
  min-height: 100dvh;
  background: var(--background2);
  padding: ${KAI_SHIKI_LAYOUT.spacing3}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CARD_STYLE = css`
  label: MOBILE_ISSUE_VIDEO_HOME_CARD_STYLE;
  width: 100%;
  max-width: 32rem;
  background: var(--background);
  border: 1px solid var(--border);
  padding: ${KAI_SHIKI_LAYOUT.spacing3}px;
  display: flex;
  flex-direction: column;
  gap: ${KAI_SHIKI_LAYOUT.spacing2}px;
`;

const TITLE_STYLE = css`
  label: MOBILE_ISSUE_VIDEO_HOME_TITLE_STYLE;
  ${KAI_SHIKI_TYPOGRAPHY.xLargeBold}
  color: var(--text);
`;

const BODY_STYLE = css`
  label: MOBILE_ISSUE_VIDEO_HOME_BODY_STYLE;
  ${KAI_SHIKI_TYPOGRAPHY.medium}
  color: var(--text2);
`;

export const MobileIssueVideoHomePage = ({
  showVideoUpload = false,
}: {
  showVideoUpload?: boolean;
}) => {
  usePageTitle('Kai Availability');
  const navigate = useNavigate();

  return (
    <div css={PAGE_STYLE}>
      <div css={CARD_STYLE}>
        <div css={TITLE_STYLE}>Kai Availability</div>
        <div css={BODY_STYLE}>
          Kai is currently only available via desktop and iPadOS app. iPhone app coming soon!
        </div>
        {showVideoUpload && (
          <Button onClick={() => navigate('/video-upload')} buttonStyle='darkBlue'>
            Submit Video
          </Button>
        )}
      </div>
    </div>
  );
};
